"use client";

import {
  concernOptionsFor,
  type Concern,
} from "@/lib/onboarding/constants";

import { professionOf } from "@/lib/onboarding/flow";

import type { StepProps } from "../types";
import {
  ContinueButton,
  OptionCard,
  OptionGroup,
  StepFooter,
  StepHeader,
} from "../ui";

const TITLE = "What worries you most about test day?";

/** Multi-select. Picks are recorded as they're toggled (`update`), and the
 *  button advances; picking nothing is a valid answer, so the button reads
 *  "None of these" until something is ticked. Options are scoped to the
 *  profession by data (`CONCERN_OPTIONS[].professions`), not by a branch here. */
export function ConcernsStep({ state, update, advance }: StepProps) {
  const profession = professionOf(state) ?? "ems";
  const options = concernOptionsFor(profession);
  const picked: ReadonlyArray<Concern> = state.answers.concerns ?? [];

  const toggle = (value: Concern) => {
    const next = picked.includes(value)
      ? picked.filter((c) => c !== value)
      : [...picked, value];
    update({ concerns: next });
  };

  return (
    <>
      <StepHeader
        kicker="Test day"
        title={TITLE}
        body="Pick any that apply."
      />
      <OptionGroup label={TITLE} className="mt-7">
        {options.map((opt) => (
          <OptionCard
            key={opt.value}
            label={opt.label}
            multi
            selected={picked.includes(opt.value)}
            onSelect={() => toggle(opt.value)}
          />
        ))}
      </OptionGroup>
      <StepFooter>
        <ContinueButton onClick={() => advance()}>
          {picked.length === 0 ? "None of these" : "That's it"}
        </ContinueButton>
      </StepFooter>
    </>
  );
}
